<script setup lang="ts">
import StreamsPage from '../features/streams/StreamsPage.vue';
</script>

<template>
  <StreamsPage />
</template>
